import React from 'react'
import { ExpedienteDespacho } from '../PaginaDespachoPortuario'

interface Props {
  expediente: ExpedienteDespacho
}

export const HojaTarjaSSA: React.FC<Props> = ({ expediente }) => {
  const folioTarja = `TRJ-SSA-${expediente.folio.replace(/[^0-9]/g, '').slice(-5) || '88124'}`
  const fechaIngreso = '04/10/2026 14:18:22 hrs'
  const pesoBrutoTotal = expediente.contenedor.pesoBrutoKg + 13600 // Camión + Contenedor
  const pesoTaraCamion = 13600
  const pesoVGMReal = expediente.contenedor.pesoBrutoKg
  const vgmDeclarado = expediente.contenedor.vgmDeclaradoKg
  const diferenciaVGM = Math.abs(pesoVGMReal - vgmDeclarado)
  const solasAprobado = diferenciaVGM <= 500

  const tarjaFirmada = expediente.tarjaInternacion.firmadaPorReceptor
  const esDiscrepancia = expediente.tarjaInternacion.resultado === 'DISCREPANCIA'

  return (
    <div className="relative w-full bg-[#fbfbf8] text-slate-900 shadow-2xl rounded-sm p-6 sm:p-10 font-sans border border-slate-300 print:border-none print:shadow-none print:p-4 text-[10px] sm:text-[11px] leading-tight select-none">
      {/* Marca de Agua Terminal SSA */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-[0.03] overflow-hidden">
        <div className="text-[95px] font-black uppercase text-slate-800 -rotate-25 select-none tracking-widest whitespace-nowrap">
          SSA MÉXICO TERMINAL
        </div>
      </div>

      {/* Encabezado SSA Marine Manzanillo */}
      <div className="border-b-2 border-slate-900 pb-3 mb-3 flex items-start justify-between">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded bg-slate-900 text-white font-black text-xs flex flex-col items-center justify-center font-mono">
            <span className="text-[11px] text-amber-400">SSA</span>
            <span className="text-[7px]">MEX</span>
          </div>
          <div>
            <h2 className="text-base sm:text-lg font-black tracking-tight text-slate-950 uppercase font-mono">
              SSA MÉXICO S.A. DE C.V.
            </h2>
            <p className="text-[9px] font-bold text-slate-600 uppercase">
              TERMINAL ESPECIALIZADA DE CONTENEDORES (TEC I) · PUERTO DE MANZANILLO, COLIMA
            </p>
            <p className="text-[8px] font-mono text-slate-500">
              SISTEMA OPERATIVO DE TERMINAL (TOS TIDEWORKS FORECAST) · TARJA DE INTERNACIÓN Y PESAJE BP1
            </p>
          </div>
        </div>

        <div className="text-right">
          <span className="font-mono text-xs font-black text-blue-900 bg-blue-50 border border-blue-200 px-2.5 py-0.5 rounded">
            FOLIO TOS: {folioTarja}
          </span>
          <p className="font-mono text-[9px] text-slate-700 font-bold mt-1">CARRIL: GATE-IN LANE 04 (BALANZA)</p>
          <p className="font-mono text-[8px] text-slate-500">FECHA: {fechaIngreso}</p>
        </div>
      </div>

      {/* Cuadrícula de Operación y Buque */}
      <div className="border border-slate-900 grid grid-cols-12 divide-x divide-slate-400 font-mono text-[9px] bg-slate-100/60 mb-2">
        <div className="col-span-3 p-1.5">
          <span className="font-sans font-bold uppercase text-[7.5px] text-slate-500 block">TIPO OPERACIÓN:</span>
          <span className="font-black text-xs text-slate-950">
            {expediente.tipoOperacion === 'EXPORTACION' ? 'INGRESO EXPORTACIÓN (FCL)' : 'DESCARGA IMPORTACIÓN'}
          </span>
        </div>
        <div className="col-span-3 p-1.5">
          <span className="font-sans font-bold uppercase text-[7.5px] text-slate-500 block">BUQUE ASIGNADO:</span>
          <span className="font-bold text-slate-900 uppercase truncate block">{expediente.buque.nombre}</span>
        </div>
        <div className="col-span-3 p-1.5">
          <span className="font-sans font-bold uppercase text-[7.5px] text-slate-500 block">VIAJE / PUERTO DESTINO:</span>
          <span className="font-bold text-slate-900 uppercase">
            V.{expediente.buque.viaje} · {expediente.buque.puertoDestino.split(',')[0]}
          </span>
        </div>
        <div className="col-span-3 p-1.5">
          <span className="font-sans font-bold uppercase text-[7.5px] text-slate-500 block">LÍNEA NAVIERA:</span>
          <span className="font-bold text-slate-900 uppercase">{expediente.contenedor.lineaNaviera}</span>
        </div>
      </div>

      {/* Bloque de Báscula Electrónica BP1 (Ticket de Pesaje Integrado) */}
      <div className="border-2 border-slate-900 mb-2">
        <div className="bg-slate-900 text-white px-2 py-0.5 font-bold text-[8.5px] uppercase tracking-wider flex justify-between items-center">
          <span>CERTIFICADO DE PESAJE EN BÁSCULA DE GARITA (SERVICIO BP1 - CONVENIO SOLAS)</span>
          <span className="text-amber-300 font-mono text-[8px]">BÁSCULA FISCAL: BP-01 AUTORIZADA ASIPONA</span>
        </div>

        <div className="grid grid-cols-12 divide-x divide-slate-300 font-mono text-[9px] p-2 bg-white">
          <div className="col-span-3 pr-2">
            <span className="block text-[7.5px] font-sans font-bold text-slate-500 uppercase">PESO TOTAL VEHICULAR:</span>
            <span className="font-bold text-sm text-slate-950">{pesoBrutoTotal.toLocaleString()} KG</span>
            <p className="text-[7.5px] text-slate-500 mt-0.5">TRACTO + CHASIS + CARGA</p>
          </div>

          <div className="col-span-3 px-2">
            <span className="block text-[7.5px] font-sans font-bold text-slate-500 uppercase">TARA VEHÍCULO (RESTADA):</span>
            <span className="font-bold text-sm text-slate-800">{pesoTaraCamion.toLocaleString()} KG</span>
            <p className="text-[7.5px] text-slate-500 mt-0.5">PLACAS: {expediente.actores.transportista.placas}</p>
          </div>

          <div className="col-span-3 px-2">
            <span className="block text-[7.5px] font-sans font-bold text-slate-500 uppercase">VGM REAL EN BÁSCULA:</span>
            <span className="font-black text-sm text-blue-950">{pesoVGMReal.toLocaleString()} KG</span>
            <p className="text-[7.5px] text-slate-500 mt-0.5">
              TARA CNTR: {expediente.contenedor.taraKg.toLocaleString()} KG
            </p>
          </div>

          <div className="col-span-3 pl-2">
            <span className="block text-[7.5px] font-sans font-bold text-slate-500 uppercase">DICTAMEN BÁSCULA:</span>
            <span
              className={`font-black text-xs px-2 py-0.5 rounded inline-block ${
                solasAprobado ? 'bg-emerald-100 text-emerald-800' : 'bg-rose-100 text-rose-800'
              }`}
            >
              {solasAprobado ? '✓ CUMPLE SOLAS (±0 KG)' : '✗ EXCESO > 500 KG'}
            </span>
            <p className="text-[7.5px] text-slate-500 mt-0.5">MAX GROSS: 32,500 KG OK</p>
          </div>
        </div>
      </div>

      {/* Ficha del Contenedor e Inspección de 7 Puntos C-TPAT */}
      <div className="border border-slate-900 mb-2">
        <div className="bg-slate-200 px-2 py-0.5 font-bold text-[8px] uppercase tracking-wider text-slate-800 border-b border-slate-900">
          INSPECCIÓN FÍSICA Y SEGURIDAD PERIMETRAL DEL EQUIPO (7 PUNTOS C-TPAT / OEA)
        </div>

        <div className="grid grid-cols-12 divide-x divide-slate-300 font-mono text-[9px] p-2 bg-white">
          <div className="col-span-4 pr-2 space-y-1">
            <div>
              <span className="block text-[7.5px] font-sans font-bold text-slate-500 uppercase">NÚMERO DE CONTENEDOR:</span>
              <span className="font-black text-sm text-slate-950 tracking-wider">
                {expediente.contenedor.numero}
              </span>
            </div>
            <p className="text-[8px] text-slate-600">
              TIPO: <strong className="text-slate-900">{expediente.contenedor.tipo}</strong> | LÍNEA:{' '}
              {expediente.contenedor.lineaNaviera}
            </p>
            <div className="p-1 rounded bg-slate-50 border border-slate-200">
              <span className="block text-[7px] font-sans font-bold text-slate-500 uppercase">PRECINTOS VERIFICADOS:</span>
              <p className="text-[8px] font-bold text-slate-900">{expediente.contenedor.sellos}</p>
            </div>
          </div>

          <div className="col-span-4 px-2 space-y-1 font-sans">
            <span className="block text-[7.5px] font-bold text-slate-500 uppercase">CHECKLIST DE INTEGRIDAD:</span>
            <div className="grid grid-cols-2 gap-1 text-[8px]">
              <span className="text-emerald-700 font-bold">✓ Frente estructural OK</span>
              <span className="text-emerald-700 font-bold">✓ Costados intactos</span>
              <span className="text-emerald-700 font-bold">✓ Techo sin perforar</span>
              <span className="text-emerald-700 font-bold">✓ Piso limpio / seco</span>
              <span className="text-emerald-700 font-bold">✓ Puertas & empaques OK</span>
              <span className="text-emerald-700 font-bold">✓ Mecanismo cerrojo OK</span>
            </div>
            <p className="text-[7.5px] text-slate-500 font-mono mt-1">
              OBS: UNIDAD APTA PARA EMBARQUE EN BUQUE.
            </p>
          </div>

          <div className="col-span-4 pl-2 space-y-1">
            <span className="block text-[7.5px] font-sans font-bold text-slate-500 uppercase">
              UBICACIÓN EN PATIO DE MANIOBRAS:
            </span>
            <div className="p-1.5 rounded bg-amber-50 border border-amber-200 text-center font-mono">
              <span className="block text-[7px] text-amber-700 font-sans font-bold uppercase">YARD SLOT FORECAST:</span>
              <span className="font-black text-sm text-amber-950">B04 - 18 - 02 - 3</span>
              <span className="block text-[7px] text-amber-700 font-sans">BLOQUE 04 · BAHÍA 18 · FILA 02 · NIVEL 3</span>
            </div>
          </div>
        </div>
      </div>

      {/* Transportista y Operador Autorizado */}
      <div className="border border-slate-900 grid grid-cols-12 divide-x divide-slate-400 font-mono text-[9px] bg-slate-50 mb-3">
        <div className="col-span-4 p-1.5">
          <span className="font-sans font-bold uppercase text-[7.5px] text-slate-500 block">LÍNEA DE TRANSPORTE:</span>
          <span className="font-bold text-slate-900 truncate block">
            {expediente.actores.transportista.razonSocial}
          </span>
          <span className="text-[7.5px] text-slate-600">CAAT: {expediente.actores.transportista.caat}</span>
        </div>

        <div className="col-span-4 p-1.5">
          <span className="font-sans font-bold uppercase text-[7.5px] text-slate-500 block">OPERADOR / CHOFER:</span>
          <span className="font-bold text-slate-900 truncate block">{expediente.actores.transportista.chofer}</span>
          <span className="text-[7.5px] text-slate-600">LIC. FEDERAL: B-88129033</span>
        </div>

        <div className="col-span-4 p-1.5">
          <span className="font-sans font-bold uppercase text-[7.5px] text-slate-500 block">PASE PIS / CITA ASIPONA:</span>
          <span className="font-bold text-blue-900">{expediente.documentos.pasePIS.codigoCita}</span>
          <span className="text-[7.5px] text-emerald-700 block font-bold">CITA CUMPLIDA EN HORARIO</span>
        </div>
      </div>

      {/* ========================================================================= */}
      {/* SECCIÓN CRÍTICA: RECEPCIÓN Y FIRMA DEL ALUMNO RECEPTOR / CONSIGNATARIO */}
      {/* ========================================================================= */}
      <div className="border-2 border-slate-900 p-3 bg-white font-mono text-[8px] relative">
        <div className="grid grid-cols-12 gap-4 items-center">
          {/* Firma Supervisor de Garita SSA */}
          <div className="col-span-4 text-center border-r border-slate-300 pr-3">
            <div className="h-10 flex items-center justify-center">
              <span className="font-serif italic text-base text-slate-800 tracking-tight">Ing. Manuel Prado S.</span>
            </div>
            <div className="border-t border-slate-800 pt-0.5">
              <span className="font-sans font-bold text-[7.5px] uppercase text-slate-800 block">
                SUPERVISOR DE GARITA Y BÁSCULA
              </span>
              <span className="text-[6.5px] text-slate-500">SSA MÉXICO TEC I MANZANILLO</span>
            </div>
          </div>

          {/* Firma y Dictamen del Receptor / Consignatario */}
          <div className="col-span-8 pl-2">
            <span className="font-sans font-bold text-[8px] uppercase text-purple-900 block mb-1">
              CONSTANCIA DE RECEPCIÓN / AUDITORÍA DEL CONSIGNATARIO (ALUMNO RECEPTOR):
            </span>

            {tarjaFirmada ? (
              <div className="space-y-1 bg-purple-50/70 p-2 rounded border border-purple-200">
                <div className="flex items-center justify-between">
                  <p className="font-bold text-xs text-purple-950 font-sans">
                    {expediente.actores.receptor.alumnoNombre || 'Alumno Receptor Asignado'}
                  </p>
                  <span className="text-[7.5px] text-purple-800 font-mono">
                    FIRMADO EL: {expediente.tarjaInternacion.fechaFirma || '04/10/2026 15:30'}
                  </span>
                </div>
                <p className="text-[8px] text-slate-700 italic">
                  "{expediente.tarjaInternacion.observacionesReceptor || 'Cotejo conforme con Factura y B/L sin discrepancias en peso ni sellos.'}"
                </p>
                <div className="text-[7px] text-purple-700 font-bold uppercase">
                  ENTIDAD: {expediente.actores.receptor.nombre} · RFC: {expediente.actores.receptor.rfc}
                </div>
              </div>
            ) : (
              <div className="p-3 border-2 border-dashed border-amber-400 bg-amber-50/50 rounded text-center">
                <span className="font-sans font-bold text-[9px] uppercase text-amber-800 block">
                  PENDIENTE DE FIRMA POR EL ALUMNO RECEPTOR
                </span>
                <span className="text-[7.5px] text-slate-600 block mt-0.5">
                  El alumno asignado como Consignatario ({expediente.actores.receptor.alumnoNombre || 'Receptor'}) debe cotejar esta Tarja contra Factura y B/L en la Mesa del Receptor.
                </span>
              </div>
            )}
          </div>
        </div>

        {/* ========================================================================= */}
        {/* SELLOS DE GOMA REALISTAS: SSA GATE-IN Y SELLO DEL RECEPTOR */}
        {/* ========================================================================= */}
        <div className="absolute left-8 top-[-35px] pointer-events-none transform -rotate-6">
          <div className="px-3 py-1.5 rounded border-2 border-blue-900 bg-blue-50/80 backdrop-blur-sm text-blue-900 shadow-md text-center">
            <span className="text-[6.5px] font-black uppercase tracking-widest block">SSA MÉXICO · MANZANILLO</span>
            <span className="text-[8px] font-black uppercase block">TERMINAL GATE-IN OK</span>
            <span className="text-[6px] font-mono block">04/OCT/2026 14:18 · TEC I</span>
          </div>
        </div>

        {tarjaFirmada && !esDiscrepancia && (
          <div className="absolute right-6 top-[-38px] pointer-events-none transform rotate-3">
            <div className="px-4 py-2 rounded-lg border-2 border-dashed border-purple-800 bg-purple-50/85 backdrop-blur-sm text-purple-900 shadow-lg text-center">
              <span className="text-[7px] font-black uppercase tracking-wider block">CONSIGNATARIO / RECEPTOR</span>
              <span className="text-[9.5px] font-black uppercase block text-purple-950">COTEJADO Y CONFORME</span>
              <span className="text-[6.5px] font-mono block">TARJA DE INTERNACIÓN LIBERADA</span>
            </div>
          </div>
        )}

        {esDiscrepancia && (
          <div className="absolute right-6 top-[-38px] pointer-events-none transform -rotate-6">
            <div className="px-4 py-2 rounded-lg border-2 border-rose-700 bg-rose-50/90 backdrop-blur-sm text-rose-900 shadow-lg text-center">
              <span className="text-[7px] font-black uppercase tracking-wider block">AUDITORÍA ADUANAL</span>
              <span className="text-[9.5px] font-black uppercase block text-rose-950">ACTA DE DISCREPANCIA</span>
              <span className="text-[6.5px] font-mono block">RECHAZO EN RECEPCIÓN DE MUELLE</span>
            </div>
          </div>
        )}
      </div>

      <div className="mt-2 text-center text-[7px] font-mono text-slate-400">
        DOCUMENTO OPERATIVO EMITIDO POR TERMINAL ESPECIALIZADA SSA MÉXICO MANZANILLO SEGÚN PROTOCOLO C-TPAT, PBIP Y CONVENIO INTERNACIONAL SOLAS.
      </div>
    </div>
  )
}
